module.exports = __webpack_public_path__ + "static/media/fvs_valve1_104.b86c8429.jpg";